export { default as NewListsTable } from './NewListsTable';
